// Smooth scroll (Lenis): wheel and trackpad scrolling glide to their target instead of jumping in steps, so the
// scroll-linked effects (parallax, running type, brand flow) move evenly. Lenis moves the window's own scroll
// position, so every scroll listener, sticky element and IntersectionObserver keeps working. Touch scrolling stays
// native (Lenis leaves it alone by default), keyboard scrolling too. Links to a block on the same page glide there
// as well, leave the same room for the sticky jump navigation (scroll-padding) and then move the focus to the
// block, as a native jump would. Nothing of this runs with reduced motion.
import Lenis from 'lenis'
import { reducedMotion } from './motion.js'

let lenis = null

export function initSmoothScroll() {
	const update = () => (reducedMotion.matches ? stop() : start())
	reducedMotion.addEventListener('change', update)
	update()

	document.addEventListener('click', (event) => {
		const link = event.target.closest('a[href*="#"]')
		if (!lenis || !link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return
		const url = new URL(link.href, location.href)
		if (url.origin !== location.origin || url.pathname !== location.pathname || url.hash.length < 2) return
		const target = document.getElementById(decodeURIComponent(url.hash.slice(1)))
		if (!target) return

		event.preventDefault()
		// the position from the real scroll position: Lenis' own value lags behind after a native scroll (scrollbar,
		// keyboard), and an element target landed short by that much
		const padding = parseFloat(getComputedStyle(document.documentElement).scrollPaddingBlockStart) || 0
		lenis.scrollTo(target.getBoundingClientRect().top + window.scrollY - padding, {
			onComplete: () => {
				history.pushState(null, '', url.hash)
				if (!target.matches('a, button, input, select, textarea, [tabindex]')) target.setAttribute('tabindex', '-1')
				target.focus({ preventScroll: true })
			},
		})
	})
}

function start() {
	if (lenis) return
	// allowNestedScroll: open menus, the cookie dialog and sideways rows keep their own wheel scrolling
	lenis = new Lenis({ autoRaf: true, lerp: 0.085, allowNestedScroll: true })
}

function stop() {
	lenis?.destroy()
	lenis = null
}
